<div class="card">
  <div class="card-header d-flex justify-content-between">
    <span><i class="fa fa-book-open-reader"></i>&nbsp;Modificar Solicitud de Crédito {{request.code}}</span>
    <span><i class="fa fa-book"></i>&nbsp;{{creditPlan.name}}</span>

  </div>
  <div class="card-body card-body-z-index">
    <router-outlet></router-outlet>
  </div>
</div>